/**
 * Site announcement icon picker — re-exports from `lambda/shared/announcementIcons.ts`.
 * Do not duplicate the icon list here; edit the shared registry only.
 */

import type { IconType } from '@design-tokens/icons';
import {
  ANNOUNCEMENT_ICON_REGISTRY,
  DEFAULT_ANNOUNCEMENT_ICON,
  isAnnouncementIconType as isAnnouncementIconTypeShared,
  normalizeAnnouncementIconType,
} from '@lambda/shared/announcementIcons';

export { DEFAULT_ANNOUNCEMENT_ICON };

/** Icons admins can pick when publishing (super admin sees full grid). */
export const ANNOUNCEMENT_ICON_OPTIONS: { type: IconType; label: string }[] =
  ANNOUNCEMENT_ICON_REGISTRY.map((entry) => ({
    type: entry.type,
    label: entry.label,
  }));

export function isAnnouncementIconType(value: string): value is IconType {
  return isAnnouncementIconTypeShared(value);
}

export function normalizeAnnouncementIcon(value: string | undefined): IconType {
  return normalizeAnnouncementIconType(value);
}
